<template>
  <div class="q_select">
    <p>
      <b>{{ question.designator }}</b>
    </p>
    <select dir="rtl" @input="setValue($event.target.value)">
      <option></option>
      <option
        :selected="selected_option_id == option.id"
        :key="option.id"
        :value="option.id"
        :text="option.text"
        v-for="option in question.options"
        >{{ option.text }}</option
      >
    </select>
  </div>
</template>
<script>
import QuestionsHelper from '@/custom/classes/questions_helper.js'
export default {
  props: ['question', 'default_option_text', 'use_server_default'],
  name: 'q-select',
  data () {
    return {
      questions_helper: new QuestionsHelper(),
      server_answer_option_id: '',
      selected_option_id: ''
    }
  },
  mounted () {
    let server_answer_option_id = this.questions_helper.getAnsweredOptionIdsFromQuestion(this.question)
    this.server_answer_option_id = server_answer_option_id.length > 0 ? server_answer_option_id[0] : ''
    this.selected_option_id = this.getSelectedOptionId()
    this.setValue(this.selected_option_id)
  },
  methods: {
    getSelectedOptionId () {
      for (let i = 0; i < this.question.options.length; i++) {
        let option = this.question.options[i]
        if (this.isOptionSelected(option)) {
          return option.id
        }
      }
      return ''
    },
    isOptionSelected (option) {
      if (this.server_answer_option_id == option.id) {
        return true
      }
      if (this.use_server_default && option.selected_by_default == '1') {
        return true
      }
      return this.default_option_text == option.text
    },
    setValue (option_id) {
      this.$emit('input', {
        question: this.question,
        value: option_id + '',
        text: this.questions_helper.getDisplayTextForSingleOption(option_id, this.question)
      })
    }
  }
}
</script>
<style>
  .error select{
    border-color: red;
  }
  .q_select{
    margin-bottom: 30px;
  }
</style>
